var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task-details-item',{attrs:{"title":"tasks.details.applications"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('users-icon',{attrs:{"size":"20"}})]},proxy:true}])},[_vm._v("\n  "+_vm._s(_vm.count)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }